<template>
  <v-app id="app">
    <Landing v-if="isLanding" />
    <Consignee v-if="isConsignee" />
    <Home v-if="isHome" />
  </v-app>
</template>

<script>
import Landing from "@/views/Landing.vue";
import Home from "@/views/Home.vue";
import Consignee from "@/views/Consignee.vue";

export default {
  components: {
    Home,
    Landing,
    Consignee,
  },
  computed: {
    isLanding() {
      return this.$route.name === "Landing";
    },
    isConsignee() {
      return this.$route.name === "Consignee";
    },
    isHome() {
      return !this.isLanding && !this.isConsignee;
    },
  },
};
</script>
